export default __webpack_public_path__ + "static/media/LVZ WEB ICONS - EVENTS.d197a41c.svg";